<template>
  <!-- hidden PageHeaderWrapper title demo -->
  <!-- <page-header-wrapper title="新增投诉" > -->
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form-model ref="form" :model="table.subData" :rules="rules" :labelCol="$formLabelCol"
        :wrapperCol="$formWrapperCol">
        <a-form-model-item label="所属项目" :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
          :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }">
          <a-select placeholder="请选择所属项目" v-model="community_id">
            <a-select-option :value="value.id" v-for="value in table.initData.projectOptions" :key="value.id">{{
              value.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="投诉来源" :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
          :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }" prop="source">
          <a-select placeholder="请选择投诉来源" v-model="table.subData.source">
            <a-select-option value="2">电话</a-select-option>
            <a-select-option value="3">现场</a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- 三级联动 -->
        <a-form-model-item label="投诉类型" :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
          :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }" prop="category_id">
          <a-cascader :options="table.initData.categoryOptions" placeholder="请选择父级类型" v-model="table.subData.category_id"
            change-on-select />
        </a-form-model-item>

        <a-form-model-item label="联系人" :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
          :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }" prop="contacts">
          <a-input placeholder="请输入投诉人姓名" v-model="table.subData.contacts"></a-input>
        </a-form-model-item>
        <a-form-model-item label="联系电话" :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
          :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }" prop="mobile">
          <a-input placeholder="请输方式" v-model="table.subData.mobile"></a-input>
        </a-form-model-item>
        <a-form-model-item label="投诉事项" :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
          :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }" prop="body">
          <a-textarea rows="4" placeholder="请描述保修投诉内容" v-model="table.subData.body" />
        </a-form-model-item>
        <a-form-model-item label="处理人" :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
          :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }" prop="staff_id">
          <a-select v-model="table.subData.staff_id" placeholder="请选择处理人">
            <a-select-option v-for="val in table.initData.staffOptions" :key="val.id"
              :value="val.id">{{ val.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-row>
            <a-col>
              <a-button type="primary" style="margin-right: 20px" @click="handleSubmit">提交</a-button>
              <a-button style="margin-left: 8px" @click="myGoBack">取消</a-button>
            </a-col>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
// 三级联动组件
import CommunityService from "@/io/community.js";
import complaintListService from "@/io/complaint/complaintList.js";
import complaintTypeService from "@/io/complaint/complaintType.js";
export default {
  name: "CreateComplaint",
  data() {
    return {
      //   三级联动数据
      rules: {
        community_id: [
          {
            required: true,
            message: "请选择所属项目",
          }
        ],
        source: [
          {
            required: true,
            message: "请选择投诉来源",
          }
        ],
        category_id: [
          {
            required: true,
            message: "请选择投诉类型",
          }
        ],
        contacts: [
          {
            required: true,
            message: "请输入联系人",
          }
        ],
        mobile: [
          {
            required: true,
            message: "请输入联系电话",
          }
        ],
        body: [
          {
            required: true,
            message: "请输入投诉事项",
          }
        ],
        staff_id: [
          {
            required: true,
            message: "请选择处理人",
          }
        ],
      },
      community_id: [],
      table: {
        subData: {
          source: [],
          category_id: [],
          contacts: null,
          mobile: null,
          staff_id: [],
          body: null,
        },
        initData: {
          projectOptions: [],
          categoryOptions: [],
          staffOptions: [],
        },
      },
    };
  },
  watch: {
    // 监听所属项目，获取处理人
    community_id: {
      deep: true,
      handler: function () {
        this.table.subData.staff_id = []
        this.getStaffOptions();
      },
    },
  },
  mounted() {
    this.initSelectData();
  },
  methods: {
    async getStaffOptions() {
      this.table.initData.staffOptions = await CommunityService.staff(this.community_id)
    },

    async initSelectData() {
      const res = await CommunityService.listPage();
      this.table.initData.projectOptions = res.map((val) => {
        return {
          ...val,
        };
      });
      const resCate = await complaintTypeService.list();
      this.table.initData.categoryOptions = this.getTypeOptions(resCate);
    },
    // 处理分类数据
    getTypeOptions(data) {
      let reslist = [];
      if (data) {
        data.map((val) => {
          reslist.push({
            value: val.id,
            label: val.name,
            children: val.child.length > 0 ? this.getTypeOptions(val.child) : [],
          });
        });
      }
      return reslist;
    },
    // handler
    handleSubmit(e) {
      this.$beforeFormSubmit(this.$refs.form, async () => {
        const { source, category_id, contacts, mobile, staff_id, body } = this.table.subData;
        const res = await complaintListService.add(
          this.community_id,
          source,
          category_id[category_id.length - 1],
          contacts,
          mobile,
          staff_id,
          body
        );
        this.$afterFormSubmit("创建成功", () => {
          this.$router.push("/platform/complaintlist");
        });

      });
    },
    myGoBack() {
      this.$router.push("/platform/complaintlist");
    },
  },
};
</script>
